import { render, staticRenderFns } from "./modifyRatio.vue?vue&type=template&id=481e0228"
import script from "./modifyRatio.vue?vue&type=script&lang=js"
export * from "./modifyRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports